import { Injectable } from '@angular/core';
import { BackOfficeConfig } from '../interfaces/back-office-config';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VhrCmsService {
  targetVHRStorage: string = '';
  backofficeConfig: BackOfficeConfig = {} as BackOfficeConfig;

  constructor(private http: HttpClient, private configService: ConfigService) { }

  initializeVhrCmsService(): Promise<boolean> {
    this.backofficeConfig = this.configService.getBackOfficeConfig()
    this.targetVHRStorage =
      this.backofficeConfig['FLEET_VHR_TARGET_ON_LOCAL_STORAGE']
    switch (this.backofficeConfig['TRANSLATION_SOURCE']) {
      case 'LOCAL':
        return this.initializeLocalVhrCms()
      case 'BUCKET':
        return this.initializeBucketVhrCms()
      case 'BACKOFFICE':
        return this.initializeBackOfficeVhrCms()
      default:
        return new Promise<boolean>((resolve) => {
          resolve(false)
        })
    }
  }

  initializeLocalVhrCms(): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE
        this.http
          .get(`http://localhost:3000/getVhrContent/${culture}`)
          .pipe(take(1))
          .subscribe((value) => {
            localStorage.setItem(this.targetVHRStorage, JSON.stringify(value))
          })
        resolve(true)
      })
    }

    initializeBucketVhrCms(): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE
        this.http
          .get(`/fakeoffice/vhr-content/vhr-cms-content_${culture}.json`)
          .pipe(take(1))
          .subscribe((value) => {
            localStorage.setItem(this.targetVHRStorage, JSON.stringify(value))
          })
        resolve(true)
      })
    }

    initializeBackOfficeVhrCms(): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE;
        const isProduction = process.env['BO_ENV'] === "backoffice-prod";
        const domain = isProduction ? 'media.space.awsmpsa.com' : 'media-integ.space.awsmpsa.com';
        this.http
          .get(`https://${domain}/uploads/FLEET/VHR/${culture}.json`)
          .pipe(take(1))
          .subscribe((value) => {
            localStorage.setItem(this.targetVHRStorage, JSON.stringify(value))
          })
        resolve(true)
      })
    }

    getVHRCatalog(): Object {
      const translationFleet = JSON.parse(
        localStorage.getItem(this.targetVHRStorage) + ''
      )
      return translationFleet
    }
}
